export const shortString = (text: string, threshold: number): string => {
  if (text.length <= threshold) return text

  return text.substring(0, threshold - 3) + '...'
}
